export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://keginator.onrender.com';
export const SOLANA_EXPLORER_URL = 'https://explorer.solana.com';